import {
  fetchCurrentUser,
  initOAuth2Flow,
  logout,
} from 'app-redux/actions/login.actions';
import { AppState } from 'app-redux/reducers';
import {
  getCurrentUser,
  getCurrentUserLoadingStatus,
} from 'app-redux/selectors/accounts.selector';
import { IUserAccount } from 'core/accounts/models';
import { isAccessTokenAvailable } from 'core/common-methods';
import i18n from 'i18n';
import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { Button, ButtonType } from 'syngenta-digital-cropwise-react-ui-kit';

interface ILoginSelectionProps {
  currentUser?: IUserAccount;
  fetchCurrentUser?: () => Promise<any>;
  isLoadingUser?: boolean;
  logoutUser?: () => any;
}

const LoginSectionComponent: React.FC<ILoginSelectionProps> = (props) => {
  const handleLoginClick = () => {
    initOAuth2Flow();
  };
  useEffect(() => {
    if (
      isAccessTokenAvailable() &&
      !props.currentUser &&
      !props.isLoadingUser &&
      props.fetchCurrentUser
    ) {
      props.fetchCurrentUser().then();
    }
  }, []);

  if (!props.currentUser) {
    return (
      <Button type={ButtonType.default} onClick={handleLoginClick}>
        {i18n.t('Log in')}
      </Button>
    );
  }
  return null;
};

const mapStateToProps = (
  state: AppState,
  ownProps: ILoginSelectionProps,
): ILoginSelectionProps => {
  return {
    ...ownProps,
    currentUser: getCurrentUser(state),
    isLoadingUser: getCurrentUserLoadingStatus(state),
  };
};

const mapDispatchToProps = (dispatch: any) => ({
  fetchCurrentUser: () => dispatch(fetchCurrentUser()),
  logoutUser: () => dispatch(logout()),
});

export const LoginSection = connect(
  mapStateToProps,
  mapDispatchToProps,
)(LoginSectionComponent);
